const getAdjacentPosition = (rootState) => rootState.dnd.position;

export default getAdjacentPosition;
